import React from 'react';
import { LinkProps } from 'next/link';

import ChevronLeftIcon from '../../icons/chevron-left';
import Link from '../elements/link';
import { useTranslate } from '../../hooks/useTranslate';

interface Props extends LinkProps {
  pageName: string;
}

export const BackLink: React.FC<Props> = (props) => {
  const { pageName, ...linkProps } = props;
  const translate = useTranslate();

  return (
    <div className="mb-4 text-raw-umber hover:text-desert-sand hover:underline">
      <Link {...linkProps}>
        <div className="flex items-center">
          <ChevronLeftIcon className="w-4 h-4 mr-2" />
          {translate('backTo', { name: pageName })}
        </div>
      </Link>
    </div>
  );
};
